import React, { useState } from 'react'
import { Button, Icon, Modal, Header } from 'semantic-ui-react'
import { storageAPI } from '../../utils/api'
import { FileObject } from '../../utils/models'
import { observer, useStore } from '../../stores'
import { useTranslation } from 'react-i18next'

export interface DeleteButtonProps {
  file: FileObject
}

export interface DeleteButtonState {
  modalOpen: boolean
  deleting: boolean
}

const DeleteButton = observer((props: DeleteButtonProps) => {
  const { fileStore } = useStore()
  const { t } = useTranslation()

  const [modalOpen, setModalOpen] = useState(false)
  const [deleting, setDeleting] = useState(false)

  const handleModalOpen = () => setModalOpen(true)

  const handleModalClose = () => setModalOpen(false)

  const deleteFile = async () => {
    setDeleting(true)
    await storageAPI.deleteFile(props.file.Key!)
    fileStore.fetch(true)
  }

  return (
    <Modal
      trigger={
        <Button
          icon
          circular
          onClick={handleModalOpen}
          className="delete-button"
        >
          <Icon name="trash" />
        </Button>
      }
      open={modalOpen}
      onClose={handleModalClose}
      closeIcon
      size="small"
    >
      <Header icon="trash" content={t('deletingFiles')} />
      <Modal.Content>
        <p>
          {t('deletingFilesConfirm')} <b>{props.file.name}</b>?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button color="yellow" basic onClick={handleModalClose}>
          <Icon name="remove" /> {t('cancel')}
        </Button>
        <Button color="yellow" onClick={deleteFile} loading={deleting}>
          <Icon name="checkmark" /> {t('confirm')}
        </Button>
      </Modal.Actions>
    </Modal>
  )
})

export default DeleteButton
